export enum Orientation {
  portrait = 'Portrait',
  landscape = 'Landscape',
}
